import script from "./MovePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MovePanel.vue?vue&type=script&setup=true&lang=ts"

import "./MovePanel.vue?vue&type=style&index=0&id=01c75adc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c75adc"]])

export default __exports__